<template>
    <div>

        <g-card class="card-consultas-carta-header" :temCabecalho="false" :expansivel="false">
            <div class="header-detalhes-secundario">
                <div class="header-detalhes-secundario-titulo">
                    <g-button
                    class="buscar-button-header"
                    largura="35px"
                    icone="icone_voltar.svg"
                    negritoTexto
                    tamanhoIcone="10px"
                    cor="#FFFFFF"
                    altura="30px"
                    :sombreado="false"
                    @click="voltar()"
                    />
                    <div class="titulo-detalhes-cabecalho"> Resumo de Sequências </div>

                </div>
                <div class="header-icons" v-tooltip="'Abre uma janela para a impressão dos detalhes do cliente!'">
                    <g-button
                    class="botoes"
                    altura="35px"
                    largura="35px"
                    tamanhoIcone="15px"
                    icone="icone_print.svg"
                    @click="imprimir()"
                    >
                    </g-button>
                </div>
            </div>
            <!-- <div class="resumo-container">
            <div class="grid-cliente">
                <div class="titulo-conteudo-detalhes">Cliente</div>
                <div></div>
            </div>
            <div class="grid-cv">
                <div class="titulo-conteudo-detalhes">CV</div>
                <div></div>
            </div>
            <div class="grid-orcamento">
                <div class="titulo-conteudo-detalhes">Orçamento</div>
                <div class="label-conteudo"></div>
            </div>
            <div class="grid-produto">
                <div class="titulo-conteudo-detalhes">Produto</div>
                <div class="label-conteudo"></div>
            </div>
            <div class="grid-tipo">
                <div class="titulo-conteudo-detalhes">Tipo</div>
                <div class="label-conteudo"></div>
            </div>
            <div class="grid-sequencia">
                <div class="titulo-conteudo-detalhes">Sequência</div>
                <div class="label-conteudo"></div>
            </div>
            
            <div class="grid-status">
                <div class="titulo-conteudo-detalhes">Status</div>
                <div class="label-conteudo"></div>
            </div>
            </div> -->
        
        <g-data-table
            Titulo="Resumo de Sequências"
            altura="auto"
            :colunas="Colunas"
            :valores="SequenciaArray"
            :NumeroLinhas="100"
            :Filtros="Filtro"
            :FiltrosEspecificos="true"
            v-on:editar="editar"
            v-on:clickImprimir="imprimir"
            :EscondeColunaBotao="true"
            :colunaColorida="'orcamentoSequenciaEnum'"
            :GetStatusColors="'corStatus'"
            :campoAgrupador="'clienteCV'"
            :campoExibicaoGrupo="'clienteCV'"
        ></g-data-table>

        <div class="alinha-button-fluxo">
            <div class="button-fluxo">
              <g-button
              tipo="amarelo" 
              negritoTexto 
              altura="35px"
              largura="100%"
              @click.once="Continuar"
            >
            GERAR NOVO PEDIDO
            </g-button>
            </div>
        </div>

        </g-card>
    </div>
</template>

<style scoped>


.resumo-container {
    display: grid;
    grid-template-columns: repeat(5, minmax(4em, 1fr));
    grid-template-rows: repeat(2, auto);
    column-gap: 3%;
    padding: 0 50px;
}

.grid-cliente {
    grid-area: 1 / 1 / 2 /2;
}
.grid-cv {
    grid-area: 1 / 2 / 2 / 3;
}
.grid-orcamento {
    grid-area: 2 / 1 / 3 / 2;
}
.grid-produto {
    grid-area: 2 / 2 / 3 / 3;
}
.grid-tipo {
    grid-area: 2 / 3 / 3 / 4;
}
.grid-sequencia {
    grid-area: 2 / 4 / 3 / 5;
}

.grid-status {
    grid-area: 2 / 5 / 3 / 6;
}

</style>

<script>
    import ResumoSequencia from "./ResumoSequencia.js";
    export default ResumoSequencia;
</script>